import React from "react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  const year = new Date().getFullYear();

  return (
    <footer id="footer">
      <div className="footer-content">
        <h3>{t("footer.companyName")}</h3>
        <p>
          <i className="fas fa-map-marker-alt"></i> {t("footer.address")}
        </p>
        <p>
          <i className="fas fa-envelope"></i> {t("footer.emailLabel")}{" "}
          <a href="mailto:career@platinumtechnology.net">
            career@platinumtechnology.net
          </a>
        </p>
        <p>
          <i className="fas fa-phone-alt"></i> {t("footer.hotlineLabel")}{" "}
          <strong>+84 123 456 789</strong>
        </p>
        <p className="copyright">
          &copy; {` ${year} ${t("footer.copyright")}`}
        </p>
      </div>
    </footer>
  );
};

export default Footer;
